import React from 'react';

interface AvatarProps {
  name: string;
  width?: string | number;
  height?: string | number;
  fontSize?: string | number;
  onEdit?: () => void;
}

export const Avatar = ({
  name,
  width = '80px',
  height = '80px',
  fontSize = '2rem',
  onEdit,
}: AvatarProps) => {
  const initial = name.charAt(0).toUpperCase();

  return (
    <div
      className="group relative flex items-center justify-center overflow-hidden rounded-full border-2 border-gray-600 bg-accent-muted text-foreground-default light:bg-white light:text-black"
      style={{
        width,
        height,
        fontSize,
      }}
    >
      <span>{initial}</span>

      {onEdit && (
        <div
          className="absolute bottom-0 left-0 flex h-1/2
          w-full items-center justify-center bg-black bg-opacity-20
          opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        >
          <button
            onClick={onEdit}
            className="pointer rounded bg-black bg-opacity-80 px-3 py-1 text-xs text-white backdrop-blur-sm transition hover:bg-opacity-100"
          >
            EDIT
          </button>
        </div>
      )}
    </div>
  );
};
